var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageWarning32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Message/Warning32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconWarning32",
    transform: "translate(-358.000000, -132.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "04-Honeycomb-Foundation/icon/Message/Warning32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconWarning",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8674067,0.289418565 L26.0308812,21.502577 C26.3056003,21.9816885 26.1399076,22.592789 25.660796,22.8675081 C25.5093911,22.9543226 25.3379016,23 25.163373,23 L0.836424032,23 C0.284139282,23 -0.163575968,22.5522847 -0.163575968,22 C-0.163575968,21.8254715 -0.117898612,21.6539819 -0.0310840972,21.502577 L12.1323904,0.289418565 C12.4071095,-0.189692945 13.01821,-0.355385699 13.4973215,-0.0806665591 C13.6513506,0.00765263005 13.7790875,0.135389472 13.8674067,0.289418565 Z",
    id: "Triangle",
    fill: "#F95200"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Stroke",
    fill: "#FFFFFF",
    x: 12,
    y: 8,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Dot",
    fill: "#FFFFFF",
    x: 12,
    y: 18,
    width: 2,
    height: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWarning32);
export default __webpack_public_path__ + "static/media/messageWarning32.023b6ed9e040642d13505837353d59bc.svg";
export { ForwardRef as ReactComponent };